import type { TFunction } from "react-i18next"
import {
  EmployerOfRecordLiveIndicatorEnum,
  EmployerOfRecordVisaSupportEnum,
} from "@oysterhr/schema"

import { generalTabFields } from "../pages/AdminVendorsPage/VendorDetailsFieldsConfig/generalTab"
import { contactsTabFields } from "../pages/AdminVendorsPage/VendorDetailsFieldsConfig/contactsTab"
import { kleaSubsidiaryTabFields } from "../pages/AdminVendorsPage/VendorDetailsFieldsConfig/kleaSubsidiaryTab"
import { hiringOnboardingTabFields } from "../pages/AdminVendorsPage/VendorDetailsFieldsConfig/hiringOnboardingTab"
import { policiesToolsTabFields } from "../pages/AdminVendorsPage/VendorDetailsFieldsConfig/policiesToolsTab"

import { FormInitialValuesType } from "../pages/AdminVendorsPage/types"
import type { BadgeProps } from "@oysterhr/ui"

type LiveStatusMap = {
  [key in EmployerOfRecordLiveIndicatorEnum]: {
    text: string
    style: BadgeProps["variation"]
  }
}

export const liveStatusMapping = (
  t: TFunction<"staff_interface/VendorsPage", string>,
): LiveStatusMap => {
  return {
    [EmployerOfRecordLiveIndicatorEnum.Live]: {
      text: t("live"),
      style: "success",
    },
    [EmployerOfRecordLiveIndicatorEnum.LiveConditional]: {
      text: t("liveConditional"),
      style: "success",
    },
    [EmployerOfRecordLiveIndicatorEnum.NotLive]: {
      text: t("notLive"),
      style: "error",
    },
    [EmployerOfRecordLiveIndicatorEnum.LaunchInProgress]: {
      text: t("launchInProgress"),
      style: "gray",
    },
  }
}

export const visaSupportMapping = {
  [EmployerOfRecordVisaSupportEnum.Yes]: true,
  [EmployerOfRecordVisaSupportEnum.Maybe]: true,
  [EmployerOfRecordVisaSupportEnum.No]: false,
}

export const tabFields = {
  general: generalTabFields,
  contacts: contactsTabFields,
  hiringOnboarding: hiringOnboardingTabFields,
  finance: () => [],
  policiesTools: policiesToolsTabFields,
  kleaSubsidiary: kleaSubsidiaryTabFields,
}

export const notDetailsFields = [
  "country",
  "direct",
  "notes",
  "position",
  "name",
  "engagedTeamMembers",
  "cutOffMonthDay",
  "liveIndicator",
  "payrollToolNotes",
  "payrollToolLink",
  "expensesToolNotes",
  "expensesToolLink",
  "timesheetToolNotes",
  "timesheetToolLink",
  "timeOffToolNotes",
  "timeOffToolLink",
  "kleaIdentifier",
  "kleaLegalName",
  "statutoryAddress",
  "statutoryCountry",
  "statutoryLocation",
]

export const KleaSubsidiaryFields: (keyof FormInitialValuesType)[] = [
  "kleaIdentifier",
  "kleaLegalName",
  "statutoryAddress",
  "statutoryCountry",
  "statutoryLocation",
]

// returns i.e for 10 -> "10th"
export function getOrdinalSuffixOfNumber(number: number): string {
  const numbers = number.toString().split("")
  const firstNumber = numbers.length > 1 ? Number(numbers[0]) : undefined
  const lastNumber = Number(numbers.pop())

  const wholeNumber = firstNumber ? `${firstNumber}${lastNumber}` : `${lastNumber}`

  switch (lastNumber) {
    case 1:
      return `${wholeNumber}st`
    case 2:
      return `${wholeNumber}nd`
    case 3:
      return `${wholeNumber}rd`
    default:
      return `${wholeNumber}th`
  }
}
